import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "stringFormat",
})
export class StringFormatPipe implements PipeTransform {
  transform(value: any, ...args: any[]): any {
    if (value == "NOTMARKED") {
      return "Not Marked";
    } else if (value == "NOTATTENDED") {
      return "Not Attended";
    } else if (value == "ATTENDED") {
      return "Attended";
    } else if (value == "INWARD") {
      return "Inward";
    } else if (value == "OUTWARD") {
      return "Outward";
    } else if (value == "UNSOLVED") {
      return "Un Solved";
    } else if (value == "SOLVED") {
      return "Solved";
    } else if (value == "INPROGRESS") {
      return "In Progress";
    } else if (value == "HOLD") {
      return "Hold";
    } else if (value == "SUPER_ADMIN") {
      return "Super Admin";
    } else if (value == "KARYA_KARTA") {
      return "Karya Karta";
    } else if (value == "OFFICE_ADMIN") {
      return "Office Admin";
    } else if (value == "VIEWER") {
      return "Viewer";
    } else if (value == "PROPOSED") {
      return "Proposed";
    } else if (value == "REGISTER_BOOK") {
      return "Register Book";
    } else if (value == "SCHEDULE_BOOK") {
      return "Schedule Book";
    } else if (value == "COMPLAIN") {
      return "Complaint";
    } else if (value == "DAURA") {
      return "Daura";
    } else if (value == "VIKAS_KAM") {
      return "Vikas Kam";
    } else if (value == "HIGH") {
      return "High";
    } else if (value == "MEDIUM") {
      return "Medium";
    } else if (value == "LOW") {
      return "Low";
    } else if (value == "GENERAL_VISIT") {
      return "General Visit";
    } else if (value == "INVITATION") {
      return "Invitation";
    } else if (value == "CALL_LOG") {
      return "Call Log";
    } else if (value == "TOKEN_GENERATION") {
      return "Token Generation";
    } else if (value == "COMPLETED") {
      return "Completed";
    } else if (value == "QUEUE") {
      return "Queue";
    } else if (value == "INPROCESS") {
      return "In Process";
    } else if (value == "GRADUATE") {
      return "Graduate";
    } else if (value == "UNDER_GRADUATE") {
      return "Under Graduate";
    } else if (value == "POST_GRADUATE") {
      return "Post Graduate";
    } else if (value == "IMPORTANT") {
      return "Important";
    } else if (value == "REGULAR") {
      return "Regular";
    } else if (value == "Pani") {
      return "पाणी";
    } else if (value == "Light") {
      return "वीज";
    } else if (value == "Drainage") {
      return "ड्रेनेज";
    } else if (value == "Raste") {
      return "रस्ते";
    } else if (value == "Safsafai") {
      return "साफसफाई (कचरा उचलने)";
    } else if (value == "Zade") {
      return "झाडे (झाडे कापणे व कापलेली झाडे उचलणे)";
    } else if (value == "Dengue_Favarni") {
      return "डेंग्यू फवारणी";
    } else if (value == "Mahapalike_sandarbhat") {
      return "महापालिके संदर्भात";
    } else if (value == "Itar") {
      return "इतर";
    } else if (value == "FAILED") {
      return "Failed";
    } else {
      return value;
    }
  }
}
